const darkColorMap = {
  // Gray
  'text-white': 'dark:text-gray-900',
  'text-gray-50': 'dark:text-gray-800',
  'text-gray-100': 'dark:text-gray-700',
  'text-gray-200': 'dark:text-gray-600',
  'text-gray-300': 'dark:text-gray-500',
  'text-gray-400': 'dark:text-gray-400',
  'text-gray-500': 'dark:text-gray-300',
  'text-gray-600': 'dark:text-gray-200',
  'text-gray-700': 'dark:text-gray-100',
  'text-gray-800': 'dark:text-gray-50',
  'text-gray-900': 'dark:text-white',

  // Green
  'text-green-50': 'dark:text-green-900',
  'text-green-100': 'dark:text-green-800',
  'text-green-200': 'dark:text-green-700',
  'text-green-300': 'dark:text-green-600',
  'text-green-400': 'dark:text-green-500',
  'text-green-500': 'dark:text-green-400',
  'text-green-600': 'dark:text-green-300',
  'text-green-700': 'dark:text-green-200',
  'text-green-800': 'dark:text-green-100',
  'text-green-900': 'dark:text-green-50',

  // Red
  'text-red-50': 'dark:text-red-900',
  'text-red-100': 'dark:text-red-800',
  'text-red-200': 'dark:text-red-700',
  'text-red-300': 'dark:text-red-600',
  'text-red-400': 'dark:text-red-500',
  'text-red-500': 'dark:text-red-400',
  'text-red-600': 'dark:text-red-300',
  'text-red-700': 'dark:text-red-200',
  'text-red-800': 'dark:text-red-100',
  'text-red-900': 'dark:text-red-50',

  // Yellow
  'text-yellow-50': 'dark:text-yellow-900',
  'text-yellow-100': 'dark:text-yellow-800',
  'text-yellow-200': 'dark:text-yellow-700',
  'text-yellow-300': 'dark:text-yellow-600',
  'text-yellow-400': 'dark:text-yellow-500',
  'text-yellow-500': 'dark:text-yellow-400',
  'text-yellow-600': 'dark:text-yellow-300',
  'text-yellow-700': 'dark:text-yellow-200',
  'text-yellow-800': 'dark:text-yellow-100',
  'text-yellow-900': 'dark:text-yellow-50',

  // Indigo
  'text-indigo-50': 'dark:text-indigo-900',
  'text-indigo-100': 'dark:text-indigo-800',
  'text-indigo-200': 'dark:text-indigo-700',
  'text-indigo-300': 'dark:text-indigo-600',
  'text-indigo-400': 'dark:text-indigo-500',
  'text-indigo-500': 'dark:text-indigo-400',
  'text-indigo-600': 'dark:text-indigo-300',
  'text-indigo-700': 'dark:text-indigo-200',
  'text-indigo-800': 'dark:text-indigo-100',
  'text-indigo-900': 'dark:text-indigo-50',
}

const darkBgColorMap = {
  // Gray
  'bg-gray-100': 'dark:bg-gray-600', // Needs to be lighter than the others to be visible in cards

  // Green
  'bg-green-100': 'dark:bg-green-800',

  // Red
  'bg-red-100': 'dark:bg-red-800',

  // Yellow
  'bg-yellow-100': 'dark:bg-yellow-800',

  // Indigo
  'bg-indigo-100': 'dark:bg-indigo-800',

  // Blue
  'bg-blue-100': 'dark:bg-blue-800',

  // Purple
  'bg-purple-100': 'dark:bg-purple-800',

  // Pink
  'bg-pink-100': 'dark:bg-pink-800',
}

export function colorClasses(color) {
  if (!color) return null

  if (!darkColorMap[color]) console.log('No dark color defined for ' + color)

  return color + ' ' + darkColorMap[color]
}

export function bgColorClasses(color) {
  if (!color) return null

  if (!darkBgColorMap[color])
    console.log('No dark bg color defined for ' + color)

  return color + ' ' + darkBgColorMap[color]
}
